module.exports = __webpack_public_path__ + "static/media/droopy_lower.36502c24.svg";